export const API_PATH = process.env.REACT_APP_API_URL
export const DOCUMENTOS_BUCKET = process.env.REACT_APP_DOCUMENTOS_BUCKET
export const DOCUMENTOS_OCR_BUCKET = process.env.REACT_APP_DOCUMENTOS_OCR_BUCKET
export const FTRADER_PROXY_URL = process.env.REACT_APP_FTRADER_PROXY_URL